import { Injectable } from '@angular/core';
import {
  buildGoogleCalendarUrl,
  buildOutlookCalendarUrl,
  CalendarEvent,
  generateICalendar,
} from '@workspace/data-types';

@Injectable({
  providedIn: 'root',
})
export class CalendarExportService {
  /**
   * Télécharge un ou plusieurs événements sous forme de fichier .ics conforme au standard RFC 5545.
   */
  public downloadICalFile(events: CalendarEvent | CalendarEvent[], filename?: string): void {
    const icsContent = generateICalendar(events);
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });

    let finalFilename = filename;
    if (!finalFilename) {
      if (Array.isArray(events)) {
        finalFilename = `agenda-etxe-${new Date().toISOString().slice(0, 10)}.ics`;
      } else {
        const sanitizedTitle = (events.title || 'evenement')
          .toLowerCase()
          .replace(/[^a-z0-9]/gi, '_')
          .slice(0, 30);
        finalFilename = `${sanitizedTitle}.ics`;
      }
    }

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = finalFilename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  /**
   * Ouvre la page d'ajout d'événement dans Google Agenda dans un nouvel onglet.
   */
  public openGoogleCalendar(event: CalendarEvent): void {
    const url = buildGoogleCalendarUrl(event);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  /**
   * Ouvre la page d'ajout d'événement dans Outlook Web dans un nouvel onglet.
   */
  public openOutlookCalendar(event: CalendarEvent): void {
    const url = buildOutlookCalendarUrl(event);
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
